export const customBreakpoint = '@media (min-width: 352px) and (max-width: 450px)'
export const largeGapGridTemplateColumns = '0.34fr 0.29fr 0.37fr'
export const smallGapGridTemplateColumns = '0.4fr 0.29fr 0.31fr'
